import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import V5Topbar from '../../components/V5Topbar';
import V5HomePage from './components/V5HomePage';

const SITE_URL = 'https://www.praesidiocare.com';
const OG_IMAGE = `${SITE_URL}/og-praesidio.jpg`; // lives in /public

const Homepage = () => {
  useEffect(() => {
    // Smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Praesidio Care | Software, Web and App Development in Nashik</title>
        <meta name="google-site-verification" content="dlFusHSfcOqkZZjK96c9v-8UZ2OeBkXwHBAG4klu1NI" />

        {/* Search + share meta */}
        <meta
          name="description"
          content="Praesidio Care is a software company in Nashik, Maharashtra. We deliver websites, apps, and custom software for businesses across India, and we are ready to start. Write to contact@praesidiocare.com."
        />
        <meta
          name="keywords"
          content="software company in Nashik, software company in Maharashtra, software company in India, app development company, web development company, Praesidio Care, Nashik, Maharashtra"
        />
        <meta name="robots" content="index,follow" />

        {/* Open Graph */}
        <meta property="og:title" content="Praesidio Care | Software, Web and App Development in Nashik" />
        <meta
          property="og:description"
          content="Websites, apps, and custom software from Nashik, for Maharashtra and India. Ready to start. contact@praesidiocare.com"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={SITE_URL} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:alt" content="Praesidio Care, software, web and app development in Nashik" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Praesidio Care | Software, Web and App Development in Nashik" />
        <meta
          name="twitter:description"
          content="Websites, apps, and custom software from Nashik, for Maharashtra and India. Ready to start. contact@praesidiocare.com"
        />
        <meta name="twitter:image" content={OG_IMAGE} />

        {/* Canonical (prefer the root as the canonical homepage) */}
        <link rel="canonical" href={SITE_URL} />

        {/* Organization schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Praesidio Care Private Limited',
            url: SITE_URL,
            email: 'contact@praesidiocare.com',
            description:
              'Software company in Nashik, Maharashtra. Websites, apps, and custom software for businesses across India.',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Nashik',
              addressRegion: 'Maharashtra',
              postalCode: '422001',
              addressCountry: 'IN',
            },
            sameAs: [
              'https://www.linkedin.com/company/praesidiocare',
              'https://twitter.com/praesidiocare',
              'https://youtube.com/@praesidiocare'
            ],
            logo: `${SITE_URL}/logo.png`
          })}
        </script>
      </Helmet>

      <div className="min-h-screen">
        <V5Topbar />
        <Header />
        <main className="relative">
          <V5HomePage />
        </main>
      </div>
    </>
  );
};

export default Homepage;
